import React from 'react';
import './footer.scss';

export const Footer = ({ children, style }) => (
  <footer style={style} className="footer">
    {children}
  </footer>
);
